
import { CTASection } from "@/components/CTASection";

export const WisdomToothCTA = () => {
  const handleBookAppointment = () => {
    window.open("https://www.healthcoco.com/nagpur/doctor/dr-hemant-asrani-endodontist-dentist/USRH249D644", "_blank");
  };

  return (
    <CTASection
      title="Relief from Wisdom Tooth Pain"
      description="At Asrani Dental in Sadar, Nagpur, our expert wisdom tooth removal services can provide immediate relief and prevent future complications. Schedule your consultation today."
      primaryButtonText="Book an Appointment"
      secondaryButtonText="Learn More"
      primaryButtonAction={handleBookAppointment}
      secondaryButtonAction={() => window.location.href = "/about"}
    />
  );
};
